<template>
  <div class="warp-box flex-direction-box">
    <el-table
      class="g-table flex-direction-box"
      :data="serveList"
      stripe
      style="width: 100%; border-bottom: 0; margin-top: -10px; max-height: 100%"
      size="mini"
    >
      <template slot="empty">
        <el-button v-if="servesListLoading" type="text" :loading="true"
          >加载中</el-button
        >
        <span v-if="!servesListLoading">暂无数据</span>
      </template>
      <el-table-column
        prop="assessmentFiled.assessmentFiledTheme"
        label="考核主题"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="assessmentFiled.assessmentFiledIndex"
        label="考核指标"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="assessmentFiled.assessmentFiledScore"
        label="考核标准分"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="assessmentFiled.assessmentFiledStandard"
        label="评分标准"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="附件信息" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button
            :disabled="!scope.row.assessmentFiled.assessmentFiledFile"
            size="mini"
            type="success"
            @click.stop="detail(scope.row, scope.$index)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="assessmentCompanyFiled.assessmentCompanyFiledScore"
        label="自评分"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="assessmentCompanyFiled.assessmentCompanyFiledIndex"
        label="自评备注"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
    </el-table>

    <el-dialog
      title="附件信息查看"
      class="append-body"
      :visible.sync="serverDetailDialog"
      :append-to-body="true"
      width="750px"
      center
      top="3%"
      :close-on-click-modal="true"
    >
      <div class="warp-box flex-direction-box">
        <el-table
          class="g-table flex-direction-box"
          :data="fileList"
          stripe
          style="
            width: 100%;
            border-bottom: 0;
            margin-top: -10px;
            max-height: 100%;
          "
          size="mini"
        >
          <template slot="empty">
            <el-button v-if="servesListLoading" type="text" :loading="true"
              >加载中</el-button
            >
            <span v-if="!servesListLoading">暂无数据</span>
          </template>

          <el-table-column
            prop="assessmentCompanyFileName"
            label="附件名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="附件信息" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click.stop="preview(scope.row, scope.$index)"
                >预览</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click.stop="download(scope.row, scope.$index)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="text-center" style="margin: 10px 0">
          <el-button
            type="success"
            size="mini"
            @click="allDownload"
            :disabled="fileList.length == 0"
            >批量下载</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as getData from "@/service/getData";
import * as global from "@/config/mUtils";
import { saveAs } from "file-saver";
import jsZip from "jszip";
import JSZipUtils from "jszip-utils";
import { ossUrl } from "../config/env";
import axios from "axios";
export default {
  data() {
    return {
      fileAddDialog: false,
      confirmDialog: false,
      serverAddDialog: false,
      serverEditDialog: false,
      serverDetailDialog: false,
      confirmLoading: false,
      assessmentCompanyFiledId: "",
      fileName: "",
      filters: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 10,
        totalCount: 10,
        serveType: "",
      },
      matterList: [],
      matterInfo: {},
      accountDialog: false,
      fileList: [{}],
      serveList: [],
      //   new Array(5).fill(2).map((e, i) => {
      //     return {
      //       number: i,
      //       serveType: i,
      //       serveCompanyName: i,
      //       serveContactName: i,
      //       serveContactTelephone: i,
      //       self: i,
      //       connect: i,
      //     };
      //   }),
      servesListLoading: false,
      permission: {},
    };
  },
  props: ["assessmentCompanyId"],
  created() {},
  components: {},
  mounted() {
    this.init();
  },
  methods: {
    allDownload() {
      //   window.open(
      //     `/garden/assessmentCompany/downForZip?assessmentCompanyFiledId=${this.assessmentCompanyFiledId}&requestUrl=${ossUrl}&fileName=${this.fileName}`
      //   );

      let zip = new jsZip();
      let progress = 0;
      this.fileList.forEach((e, i) => {
        let _this = this;
        JSZipUtils.getBinaryContent(
          e.assessmentCompanyFileUrl,
          function (err, binData) {
            zip.file(e.assessmentCompanyFileName, binData, { binary: true });
            ++progress;
            if (progress === _this.fileList.length) {
              zip.generateAsync({ type: "blob" }).then(function (content) {
                saveAs(content, "downForZip.zip");
              });
            }
          }
        );
      });
    },
    init() {
      getData
        .assessmentdetail({ assessmentCompanyId: this.assessmentCompanyId })
        .then((res) => {
          if (res.data.code != "success") {
            this.$message.error(res.data.message || res.data.msg);
            return;
          }
          this.serveList = res.data.data.data;
          this.submitLoading = false;
        });
    },
    detail(row, index) {
      this.assessmentCompanyFiledId =
        row.assessmentCompanyFiled.assessmentCompanyFiledId;
      this.fileName = row.assessmentFiled.assessmentFiledTheme;
      getData
        .assessmentFileList({
          assessmentCompanyFiledId:
            row.assessmentCompanyFiled.assessmentCompanyFiledId,
        })
        .then((res) => {
          if (res.data.code != "success") {
            this.$message.error(res.data.message || res.data.msg);
            return;
          }
          this.fileList = res.data.data.files;
          this.serverDetailDialog = true;
        });
    },
    preview(row, index) {
      let type = global.fileUrl(row.assessmentCompanyFileUrl);
      if (type == "word" || type == "excel") {
        window.open(
          `https://view.officeapps.live.com/op/view.aspx?src=${row.assessmentCompanyFileUrl}`
        );
      }
      if (type == "pdf" || type == "image" || type == "txt") {
        window.open(`${row.assessmentCompanyFileUrl}`);
      }
      if (type == "package") {
        this.$message.error("该文件格式附件不支持在线预览，请下载后查看");
      }
    },

    download(row, index) {
      let type = global.fileUrl(row.assessmentCompanyFileUrl);
      saveAs(row.assessmentCompanyFileUrl, row.assessmentCompanyFileName);
      return;
      if (
        type == "word" ||
        type == "excel" ||
        type == "txt" ||
        type == "package" ||
        type == "image"
      ) {
        saveAs(row.assessmentCompanyFileUrl, row.assessmentCompanyFileName);
      }

      if (type == "pdf") {
        //   var oReq = new XMLHttpRequest();
        //   var URLToPDF = row.assessmentCompanyFileUrl;
        //   oReq.open("GET", URLToPDF, true);
        //   oReq.responseType = "blob";
        //   oReq.onload = function () {
        //     var file = new Blob([oReq.response], {
        //       type: "application/pdf",
        //     });
        //     saveAs(file, row.assessmentCompanyFileName);
        //   };
        //   oReq.send();
        this.handlePdfLink(
          row.assessmentCompanyFileUrl,
          row.assessmentCompanyFileName
        );
      }
      //   if (type == "image") {
      //     const image = new Image();
      //     image.setAttribute("crossOrigin", "Anonymous");
      //     image.src = row.assessmentCompanyFileUrl;
      //     const url = global.image2base64(image);
      //     const a = document.createElement("a");
      //     a.setAttribute("href", "" + url); //a.href='文件链接'
      //     a.setAttribute("download", row.assessmentCompanyFileName); //a.download='文件名'
      //     a.click();
      //   }
    },

    handlePdfLink(url, filename) {
      var oReq = new XMLHttpRequest();
      var URLToPDF = url;
      oReq.open("GET", URLToPDF, true);
      oReq.responseType = "blob";
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: "application/pdf",
        });
        saveAs(file, filename);
      };
      oReq.send();
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/mixin";

.warp-box {
  width: 100%;
  height: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  background: $list-bg;
}

.nav-header {
  justify-content: space-between;
  padding: 10px 20px;
  background: $fc;
}

.title {
  font-size: 16px;
  font-weight: 700;

  .line {
    display: inline-block;
    height: 18px;
    width: 4px;
    background: #28cef7;
    vertical-align: middle;
    margin-right: 10px;
  }
}

.search-bar {
  padding: 10px 20px;
  border-top: 1px solid #e5e5e5;
}

.edit {
  margin-left: 5px;
  font-size: 16px;
  cursor: pointer;
  color: $blue;
}

.warp-box {
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
  }
}

.icon-img {
  width: 32px;
  height: 32px;
}

.danger {
  background: #f56c6c;
  color: #fff;
}

.g-thing-tit {
  position: relative;
  border-bottom: 1px solid #cccccc;

  h4 {
    @include sc(14px, #333);
    line-height: 40px;
    font-weight: bold;
  }

  p {
    @include sc(12px, #606266);
    line-height: 30px;
    margin-right: 20px;
  }

  .thingstate {
    position: absolute;
    top: 0;
    right: -20px;
    @include wh(80px, 30px);
    background: #169bd5;
    border-radius: 15px 0 0 15px;
    text-align: center;
    line-height: 30px;
    @include sc(13px, #fff);
  }

  .c-blue {
    @include sc(13px, #1e1e1e);
    background-color: #d7d7d7;
  }
}

.g-contp {
  margin-top: 20px;
  line-height: 24px;
  @include sc(12px, #666);
  text-indent: 2em;
}

.dialog-form {
  padding: 20px;
}

.el-pagination {
  text-align: center;
  margin-top: 20px;
  background-color: #fff;
}

#index {
  min-width: 997px;
  background: #ebeef2;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.table {
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  .nav {
    justify-content: space-between;
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
  }
}

.table_list {
  padding-top: 60px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  background: #fff;
}

.admin_list {
  width: 100%;
  overflow: auto;
}

.dialog_header {
  padding: 20px;
  box-sizing: border-box;
}

.g-checkall {
  justify-content: space-between;
  height: 40px;
  padding: 0 40px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f2f2f2;

  .el-checkbox {
    margin-left: 0;
  }
}

.el-checkbox {
  display: block;
  margin-left: 40px;
}

.g-chooseBox {
  /*height: 120px;
    overflow: auto;*/
}

.g-fliebox {
  padding: 20px;

  li {
    height: 40px;
    justify-content: space-between;
  }
}

.add-matter {
  .el-dialog {
    max-width: 780px;
    min-width: 580px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/evaluationResult.vue